const l = {
  "base.and": "ir",
  "base.toc": "Sąlygos ir nuostatos",
  "base.privacyPolicy": "Privatumo politika",
  "base.createAccount": "Sukurti paskyrą",
  "base.signin": "Prisijungti",
  "base.signup": "Registruotis",
  "base.logOut": "Atsijungti",
  "authentication.description": "Prisijunkite arba sukurkite paskyrą",
  "invitation.wrongEmailTitle": "Jau prisijungta",
  "invitation.wrongEmailText":
    "Atrodo, kad jau esate prisijungę prie kitos paskyros. Prašome atsijungti ir bandyti dar kartą.",
  "invitation.invalidLinkTitle": "Neteisingas kvietimas",
  "invitation.invalidLinkText": "Kvietimo nuoroda yra neteisinga",
  "invitation.completeSignup": "Prašome užbaigti registraciją į ",
  "invitation.completeSignupDescription":
    "Patvirtinimo el. laiškas buvo išsiųstas į jūsų adresą. Jei jo nematote savo pašto dėžutėje, prašome patikrinti nepageidaujamų laiškų aplanką.",
  "invitation.completeSignupButton": "Užbaigti registraciją",
  "invitation.mustSignupTitle": "Jūs buvote pakviesta(-s) į ",
  "invitation.signInToAccept":
    "Prašome prisijungti, kad priimtumėte kvietimą. Laiške, kurį gavote, rasi laikiną slaptažodį.",
  "invitation.acceptTermsOnSignup": "Prisijungdama(-s) automatiškai sutinkate su mūsų",
  "invitation.accept": "Prisijungti ir priimti kvietimą",
  "invitation.failed":
    "Nepavyko priimti kvietimo. Prašome pabandyti atsijungti ir prisijungti - arba paprašyti administratoriaus pakviesti jus dar kartą.",
  "invitation.accepted": "Kvietimas priimtas",
  "invitation.emailNotVerified":
    "El. paštas nepatenkintas. Prašome patvirtinti savo el. paštą ir bandyti dar kartą.",
  "country.venezuela": "Venezuela",
  "country.japan": "Japonija",
  "country.algeria": "Alžyras",
  "country.france": "Prancūzija",
  "country.spain": "Ispanija",
  "country.china": "Kinija",
  "country.usa": "JAV",
  "country.england": "Anglija",
  "country.brazil": "Brazilija",
  "country.italy": "Italija",
  "country.denmark": "Danija",
  "head.title": "Talkio AI | Praktikuokite kalbą su AI",
  "landing.title1": "Praktikuokite ",
  "landing.title2": "Kalbą ",
  "landing.title3": "su AI ",
  "landing.subtitle1":
    "Geriausia kalbų mokymosi programa, naudojanti AI technologijas, kad padėtų jums pagerinti savo kalbines įgūdžius.",
  "landing.button.freeTrial": "7 dienos nemokamai",
  "landing.creditCardNotice": "Reikalinga kreditinė kortelė - galite atsisakyti bet kada",
  "landing.text.voiceControlTeam": "Iš komandos, kuri sukūrė Voice Control for ChatGPT",
  "landing.text.trustedBy": "Pasitikėjo daugiau nei 500 000 vartotojų",
  "landing.card.title.advancedAI": "Sukurtas su pažangiomis AI technologijomis",
  "landing.card.text.advancedAI":
    "Talkio AI sukurtas su pažangiomis AI technologijomis ir leidžia jums bendrauti su AI per balsą, kad patobulintumėte savo kalbinius įgūdžius.",
  "landing.card.title.multipleLanguages": "Palaiko daugelį kalbų",
  "landing.card.text.multipleLanguages":
    "Mes siūlome įvairią kalbų pasirinkimą, įskaitant anglų, kinų, prancūzų ir daugelį kitų kalbų.",
  "landing.card.title.premiumVoice": "Premijinė balso technologija",
  "landing.card.text.premiumVoice":
    "Talkio AI siūlo premijinius balsus ir palaiko kelis dialektus populiariausiose kalbose. Su mūsų pažangiomis kalbų technologijomis galite pasinerti į autentiškas pokalbius ir įgyti įgūdžių dialektuose, kurie jums yra svarbiausi.",
  "landing.sectionTitle.meetTutors": "Susipažinkite su AI dėstytojais",
  "landing.sectionText.moreThanTutors":
    "Talkio AI turi daugiau nei 400 dėstytojų su unikaliomis dirbtinėmis asmenybėmis, pasiruošusių padėti jums jūsų kalbų kelionėje.",
  "landing.text.andManyMore": "Ir dar daugiau",
  "landing.text.learnWithAITutors": "Mokykitės su AI dėstytojais",
  "landing.text.wonderedAboutTutor":
    "Ar kada nors galvojote, kaip būtų turėti asmeninį kalbų dėstytoją, prieinamą bet kada, bet kur? Talkio AI paverčiame šią svajonę realybe. Mūsų AI dėstytojai yra puikūs palydovai, norintys pagerinti jūsų kalbinius įgūdžius. Palaikomi pažangių AI technologijų, jie imituoja žmogaus sąveiką ir pokalbį, siūlydami įtraukiančią kalbų mokymosi patirtį, kuri yra tiek motyvuojanti, tiek efektyvi.",
  "landing.text.rememberLanguageLearning":
    "Atminkite, kad kalbų mokymasis yra daugiau nei tik gramatika ir žodynas; tai yra pasitikėjimo savimi išreiškimas. Su Talkio AI išmaniais dėstytojais galite kalbėti, praktikuoti ir pasiekti savo kalbų tikslus!",
  "landing.sectionTitle.featureSpotlight": "Ypatybių akcentas",
  "landing.sectionText.featureSpotlight":
    "Naršykite mūsų funkcijų asortimentą, sukurtą tam, kad jūsų kalbų mokymasis būtų įtraukiančia ir motyvuojančia kelione.",
  "landing.text.safeEnvironment": "Saugi ir palaikanti aplinka",
  "landing.text.supportiveEnvironment":
    "Mūsų programa suteikia saugią ir palaikančią aplinką, kurioje galite praktikuoti kalbėjimą su pasitikėjimu. Su Talkio AI galite turėti prasmingus pokalbius, remdamiesi AI technologijomis, leidžiančiomis jums gauti sklandumą ir išreikšti save kalba, kurią mokotės.",
  "landing.sectionTitle.insights": "Įžvalgos",
  "landing.sectionText.realStories": "Tiesioginiai pasakojimai iš realių Talkio AI vartotojų",
  "landing.sectionTitle.faq": "Dažnai užduodami klausimai",
  "landing.sectionText.faq": "Atsakymai į dažnai užduodamus klausimus apie Talkio AI",
  "landing.sectionTitle.pricing": "Kainos",
  "landing.sectionText.unlockPotential":
    "Atraskite savo kalbų potencialą su Talkio. Jūsų kelionė į meistriškumą prasideda dabar.",
  "landing.sectionText.offersForPartners": "Mes taip pat siūlome planus mokykloms ir komandoms",
  "landing.imageAlt.landing": "Pateikimas",
  "landing.imageAlt.laurelLeft": "Lauro lapai kairėje",
  "landing.imageAlt.laurelRight": "Lauro lapai dešinėje",
  "landing.imageAlt.speakingWithAI": "Moteris kalbasi su AI",
  "testimonial.text1":
    "Asmeniškai naudojau Talkio AI, kad patobulinčiau savo ispanų kalbą, ir galiu pasakyti, kad tai puiki galimybė.",
  "testimonial.text2":
    "Talkio AI yra labai įspūdingas įrankis ir turėtų būti įtrauktas į kiekvieno kalbų besimokantiesiems įrankių rinkinį.",
  "testimonial.text3": "Šis įrankis Talkio AI mane tiesiog šokiruoja kalbų mokymuisi.",
  "testimonial.text4": "Talkio AI - tai nuostabus produktas.",
  "feature.lifeLikeConversations": "Gyvybiškos pokalbiai su AI dėstytojais",
  "feature.pronunciationTool": "Taisyklingo tarimo praktikos įrankis",
  "feature.detailedFeedback": "Išsamūs atsiliepimai apie jūsų kalbėjimo įgūdžius",
  "feature.interactiveWordbook": "Interaktyvus žodynas",
  "feature.supportsLanguages": "Palaiko daugiau nei 40 kalbų",
  "landing.text.voiceConversations": "Balso pokalbiai",
  "landing.text.voiceConversationsDescription":
    "Turėkite įdomius balsų pokalbius su mūsų AI dėstytojais",
  "landing.text.pronunciation": "Taisyklingas tarimas",
  "landing.text.pronunciationDescription":
    "Įvertinkite ir praktikuokite savo tarimą su žodis po žodžio atsiliepimais",
  "landing.text.feedback": "Atsiliepimai",
  "landing.text.feedbackDescription":
    "Gaukite momentinius atsiliepimus apie savo kalbų įgūdžius ir patarimus, kaip juos tobulinti",
  "landing.text.multipleLanguages": "Daugelis kalbų ir dialektų",
  "landing.text.multipleLanguagesDescription":
    "Pasirinkite iš 134 kalbų ir dialektų, kad praktikuotumėte savo kalbėjimo įgūdžius",
  "landing.text.progress": "Progresas",
  "landing.text.progressDescription":
    "Sekite savo pažangą ir gaukite savaitinius ataskaitas apie savo kalbų mokymosi kelionę",
  "landing.text.wordbook": "Žodynas",
  "landing.text.wordbookDescription": "Išsaugokite ir peržiūrėkite per mokymąsi išmoktus žodžius",
  "landing.text.streaks": "Nepaliaujamos praktikos",
  "landing.text.streaksDescription":
    "Sekite savo progresą su nepaliaujama praktika, kad sukurtumėte mokymosi įprotį",
  "landing.text.crosstalk": "Pokalbiai dviem kalbomis",
  "landing.text.crosstalkDescription":
    "Bendraukite su dėstytoju tiek savo gimtąja kalba, tiek kalba, kurią mokotės",
  "landing.text.translations": "Vertimai",
  "landing.text.translationsDescription": "Momentiniai vertimai, palaikantys jūsų pokalbius",
  "landing.text.featureSpotlight": "Ypatybių akcentas",
  "landing.text.featureSpotlightDescription":
    "Naršykite mūsų funkcijų asortimentą, sukurtą tam, kad jūsų kalbų mokymasis būtų įtraukiančia ir motyvuojančia kelione",
  "feature.practiceSpeaking.title": "Praktikuokite kalbėjimą",
  "feature.practiceSpeaking.bullet1": "Gyvybiški pokalbiai su AI dėstytoju",
  "feature.practiceSpeaking.bullet2": "Balsu pirmiausia interakcija",
  "feature.practiceSpeaking.bullet3": "Pokalbio pagalba",
  "feature.practiceSpeaking.bullet4": "Kartoti ir bandyti dar kartą",
  "feature.worldOfLanguages.title": "Kalbų pasaulis",
  "feature.worldOfLanguages.bullet1": "Palaiko daugiau nei 40 kalbų",
  "feature.worldOfLanguages.bullet2": "Momentiniai vertimai",
  "feature.worldOfLanguages.bullet3": "Daugiakalbė balso atpažinimo sistema",
  "feature.worldOfLanguages.bullet4": "Rašmenų kalbų romanizacija",
  "feature.actionableFeedback.title": "Veiksmingi atsiliepimai",
  "feature.actionableFeedback.bullet1": "Laiškų vertinimas",
  "feature.actionableFeedback.bullet2": "Pobūdžio gerinimo strategijos",
  "feature.actionableFeedback.bullet3": "AI pasiūlymai",
  "feature.actionableFeedback.bullet4": "Kalbos tikslumo įvertinimas",
  "feature.pronunciationPractice.title": "Taisyklingo tarimo praktika",
  "feature.pronunciationPractice.bullet1": "Žodis po žodžio vertinimas",
  "feature.pronunciationPractice.bullet2": "Tarimo įvertinimas",
  "feature.pronunciationPractice.bullet3": "Tikslumas, visiškumas ir sklandumas",
  "feature.pronunciationPractice.bullet4": "Kartoti ir bandyti dar kartą",
  "feature.interactiveWordbook.title": "Interaktyvus žodynas",
  "feature.interactiveWordbook.bullet1": "Sekite išmoktų žodžių statistiką",
  "feature.interactiveWordbook.bullet2": "Sustiprinimo atmintis per dėstytojų pasikartojimą",
  "feature.interactiveWordbook.bullet3": "Vertimas ir garsinis skaitymas",
  "feature.interactiveWordbook.bullet4": "Laiškų pavyzdžiai",
  "feature.button.startTrial": "Pradėkite nemokamą bandomąjį laikotarpį",
  "faq.question1": "Ar yra nemokamas planas?",
  "faq.answer1":
    "Ne, visi planai yra mokami. Tačiau yra 7 dienų nemokamas bandomasis laikotarpis, kurį galite atšaukti bet kada. Jokių sąlygų.",
  "faq.question2": "Kas yra Talkio AI kūrėjas?",
  "faq.answer2.part1": "Talkio AI yra",
  "faq.answer2.part2":
    "produkta, įregistruota Europos Sąjungoje. Aidia ApS laikosi Generalinės duomenų apsaugos reglamento (GDPR), kad užtikrintų saugią ir patikimą patirtį visiems vartotojams.",
  "faq.question3": "Ar Talkio AI tinkamas pradedantiesiems?",
  "faq.answer3":
    "Talkio AI labiausiai tinka tiems, kurie turi pagrindines kalbos žinias ir siekia patobulinti savo kalbinius įgūdžius. Pradedantiesiems paruošėme įvadinį gido, kad padėtume jums pradėti. Šis gidas apima pagrindinius jūsų pasirinktos kalbos aspektus, paruošdamas jus visiškai pasinaudoti Talkio AI nauda. Jis yra nemokamas ir puikus įrankis mokiniams, pradedantiems savo kelionę. Susipažinkite su gidu ir pradėkite efektyviai tobulinti savo kalbų įgūdžius.",
  "faq.button.gettingStartedGuide": "Išbandykite NEMOKAMĄ pradžios gidą",
  "faq.question4": "Ar mokėjimas saugus?",
  "faq.answer4":
    "Taip, mes naudojame Stripe finansų apdorojimui. Mes nesaugome jokių jūsų kreditinės kortelės duomenų.",
  "faq.question5": "Kur saugomi mano duomenys?",
  "faq.answer5":
    "Jūsų duomenys saugomi Europos Sąjungos serveriuose: Microsoft (balsas ir duomenys), Auth0 (autentifikacija), Stripe (mokėjimai). Be to, mes naudojame OpenAI, Anthropic ir Groq paslaugas, kad įgalintume AI. Šie duomenys tvarkomi Jungtinėse Valstijose.",
  "faq.question6": "Ar galiu gauti grąžinimą?",
  "faq.answer6":
    "Nemokamą bandomąjį laikotarpį galima atšaukti bet kada; tačiau jei pamiršite atšaukti bandomąjį laikotarpį, galime jums grąžinti pinigus per 14 dienų, jeigu po bandomojo laikotarpio nebuvote naudoję paslaugos. Prašome susisiekti su mumis adresu support@talkio.ai.",
  "faq.question7": "Kokius mokėjimo metodus priimate?",
  "faq.answer7":
    "Prenumeratos metu priimame visas pagrindines kreditines korteles ir Paypal. Vienkartiniams pirkimams taip pat priimame WeChat, Przelewy24, Giropay, Alipay ir kt. Pasiekiamumas priklauso nuo jūsų vietovės.",
  "faq.question8": "Ar Talkio turi mobiliąją programėlę?",
  "faq.answer8":
    "Talkio yra progresyvi žiniatinklio programa, tai reiškia, kad galite ją įdiegti iš naršyklės, neiškeldami į programų parduotuvę ar Google Play. Naudodami Talkio, atidarydami jį savo naršyklėje, rasite įdiegimo mygtuką po registracijos. Naudodami iOS, atidarykite Talkio Safari, paspauskite bendrinimo piktogramą ir pasirinkite 'Pridėti prie pagrindinio ekrano', kad įdiegtumėte kaip įprastą programėlę savo telefone.",
  "faq.question9": "Kuriuos naršykles galiu naudoti?",
  "faq.answer9":
    "Talkio AI veikia visuose šiuolaikiniuose naršyklėse, įskaitant Chrome, Firefox, Safari ir Edge. Taip pat veikia mobiliuosiuose naršyklėse tiek iPhone, tiek Android.",
  "faq.question10": "Kokius AI modelius naudojate?",
  "faq.answer10":
    "Talkio AI naudoja skirtingų AI modelių derinį iš OpenAI, Anthropic ir Meta. Kiekvienas modelis turi konkrečią užduotį, kuria gerai atlieka, ir kartu jie sukuria galingą AI dėstytoją.",
  "faq.question11": "Kaip Talkio AI skiriasi nuo Voice Control for ChatGPT?",
  "faq.answer11":
    "Talkio AI siūlo nuoseklią patirtį su ChatGPT, pritaikyta kalbų mokymuisi. Tai siūlo daugiau funkcijų, įskaitant tarimo vertinimą, premijines balso technologijas, daugiakalbę paramą, specialiai paruoštus mokymo medžiagas, integruotus atsiliepimus ir vertimus.",
  "faq.question12": "Kaip galiu su jumis susisiekti?",
  "faq.answer12": "Labai kviečiame rašyti el. paštą adresu hello@talkio.ai",
  "layout.serviceBar.text": "Zakrenta Danijoje. Gerbiame jūsų privatumo.",
  "layout.serviceBar.community": "Prisijunkite prie pasaulinės kalbų besimokančiųjų bendruomenės",
  "layout.nav.pricing": "Kainos",
  "layout.nav.faq": "Dažnai užduodami klausimai",
  "layout.nav.languages": "Kalbos",
  "layout.nav.blog": "Tinklaraštis",
  "layout.nav.schools": "Mokykloms",
  "layout.nav.teams": "Komandoms",
  "layout.nav.affiliateProgram": "Partnerių programa",
  "layout.nav.signIn": "Prisijungti",
  "layout.nav.goToApp": "Eiti į programėlę",
  "layout.nav.menu": "Meniu",
  "layout.cta.description":
    "Geriausia kalbų mokymosi programa, naudojanti AI technologijas, kad padėtų jums pagerinti savo kalbinius įgūdžius.",
  "layout.cta.button": "Išbandykite Talkio AI",
  "layout.footer.pages": "Puslapiai",
  "layout.footer.links": "Nuorodos",
  "layout.footer.learningHub": "Mokymosi hub",
  "layout.footer.faq": "Dažnai užduodami klausimai",
  "layout.footer.blog": "Tinklaraštis",
  "layout.footer.partners": "Partneriai",
  "layout.footer.tools": "Įrankiai",
  "layout.footer.about": "Apie",
  "layout.footer.affiliateProgram": "Partnerių programa",
  "layout.footer.schools": "Talkio mokykloms",
  "layout.footer.teams": "Talkio komandoms",
  "layout.footer.languageGuide": "Nemokamas kalbų gidas",
  "layout.footer.termsConditions": "Sąlygos ir nuostatos",
  "layout.footer.privacyPolicy": "Privatumo politika",
  "layout.footer.logout": "Atsijungti",
  "layout.footer.login": "Prisijungti",
  "layout.footer.blogPosts": "Tinklaraščio įrašai",
  "layout.footer.blogPost1": "Nauja funkcija Talkio AI: Interaktyvus kalbų gidas",
  "layout.footer.blogPost2": "Talkio integruoja tris naujus pritaikytus GPT",
  "layout.footer.blogPost3":
    "Patobulinkite savo IELTS kalbėjimo įgūdžius su Talkio AI: Žingsnis po žingsnio gidas",
  "layout.footer.blogPost4": "3 efektyvūs būdai praktikuoti anglų kalbą",
  "layout.footer.blogPost5": "Išsilaikyti anglų kalbos įgūdžių testus",
  "layout.footer.blogPost6": "Mokykitės TOEFL kalbėjimo su Talkio AI: jūsų esminis gidas",
  "layout.footer.contact": "Kontaktai",
  "layout.footer.rights": "Visos teisės saugomos.",
  "layout.footer.illustrationCredits": "Pagrindinio puslapio iliustracijos autorius vectorjuice",
  "pricing.description.perMonthBilledOnce": "per mėnesį - apmokama vienu kartu",
  "pricing.description.perMonthBilledQuarterly": "per mėnesį - apmokama kas ketvirtį",
  "pricing.description.perMonthBilledBiannually": "per mėnesį - apmokama kas 6 mėnesius",
  "pricing.description.perMonthBilledYearly": "per mėnesį - apmokama kas metus",
  "pricing.description.perMonth": "per mėnesį",
  "pricing.button.buyNow": "Pirkti dabar su 7 dienų pinigų grąžinimo garantija",
  "pricing.button.startFreeTrial": "Pradėti nemokamą bandomąjį laikotarpį",
  "pricing.features.refund": "7 dienų pilnas pinigų grąžinimas - atšaukite bet kada",
  "pricing.features.freeTrial": "7 dienų nemokamas bandomasis laikotarpis - atšaukite bet kada",
  "pricing.features.supportsLanguages": "Palaiko daugiau nei 40 kalbų",
  "pricing.features.voiceConversations": "Gyvybiški balsų pokalbiai",
  "pricing.features.instantFeedback": "Momentiniai atsiliepimai",
  "pricing.features.weeklyProgressReport": "Savaitinė pažangos ataskaita",
  "pricing.features.pronunciationPractice": "Taisyklingo tarimo praktika",
  "pricing.features.interactiveWordbook": "Interaktyvus žodynas",
  "pricing.features.speechRecognition": "Daugiakalbė balso atpažinimo sistema",
  "pricing.features.extraFeatures": "Rolės, temos, testai ir dar daugiau!",
  "accessRequest.pageNotExist": "404 Puslapis neegzistuoja.",
  "accessRequest.createAccountTitle": "Sukurkite paskyrą, kad pradėtumėte",
  "accessRequest.createAccountMessage":
    "Norint prisijungti, pirmiausia reikia sukurti paskyrą. Po registracijos galite paprašyti prieigos prie sistemos.",
  "accessRequest.createAccountButton": "Sukurkite savo paskyrą",
  "accessRequest.alreadyHaveAccount": "Jau turite paskyrą?",
  "accessRequest.signIn": "Prisijungti",
  "accessRequest.grantedTitle": "Sveikiname!",
  "accessRequest.grantedMessage":
    "Sėkmingai įgijote prieigą prie {serviceName}. Spustelėkite žemiau, kad pradėtumėte naudoti programėlę.",
  "accessRequest.goToApp": "Eiti į programėlę",
  "accessRequest.accountExists": "Paskyra jau egzistuoja",
  "accessRequest.accountExistsMessage":
    "Jūs jau esate šios paskyros narys. Norėdami tęsti, prašome atsijungti ir registruotis su kita el. pašto adresu.",
  "accessRequest.logOut": "Atsijungti",
  "accessRequest.requestAccessTitle": "Prašyti prieigos tęsti",
  "accessRequest.requestAccessMessage":
    "Jūsų prašymas turi būti patvirtintas, kol galėsite gauti prieigą.",
  "accessRequest.checkBackLater": "Prašome vėl patikrinti vėliau, ar jūsų prieiga buvo suteikta.",
  "accessRequest.submitRequest": "Pateikti prašymą",
  "accessRequest.pending": "Prašymas dėl prieigos laukiamas",
};

export default l;
